import React, { Component } from "react";
import IconPDF from "ReactComponents/Shared/Icons/icon-pdf";

class Extra extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const freeMaterialGroups = this.props.freeMaterials?.FreeMaterialGroups || [];

        return (
            <div className="free-materials-tab-container">
                <div className="free-materials-tab-content">
                    <div className="free-materials__groups">
                        {freeMaterialGroups.map((item, idx) => (
                            <div className="free-materials__group" key={idx}>
                                {item.GroupType && (
                                    <h3 className="free-materials__group-title">
                                        <div
                                            className="free-materials__group-title__text"
                                            dangerouslySetInnerHTML={{ __html: item.GroupTitle }}
                                        />
                                    </h3>
                                )}
                                {item.GroupMaterials &&
                                    item.GroupMaterials.map((item, idx) => {
                                        return (
                                            <a key={idx} href={item.Url || "#"}>
                                                <IconPDF />
                                                <span
                                                    dangerouslySetInnerHTML={{
                                                        __html: item.Description + item.Extension
                                                    }}
                                                />
                                            </a>
                                        );
                                    })}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}

export default Extra;
